/**
 * Service Veille Qualiopi — aucun logique métier, uniquement des appels API.
 * Le client `api` inclut les cookies, parse le JSON et lève une Error sur réponse !ok.
 */

import { api, endpoints } from './api.js'

const e = endpoints.veille

export const veilleService = {
  list: (type) => api.get(e.list(type)),
  summary: () => api.get(e.summary()),
  diffusionConfig: () => api.get(e.diffusionConfig()),
  setDiffusionConfig: (type, payload) => api.put(e.setDiffusionConfig(type), payload),

  /** Registre « Sources & preuves » par rubrique (indicateurs Qualiopi). */
  ressources: (type) => api.get(e.ressources(type)),
  ressourceCounts: () => api.get(e.ressourceCounts()),
  createRessource: (payload) => api.post(e.createRessource(), payload),
  updateRessource: (id, payload) => api.patch(e.ressource(id), payload),
  deleteRessource: (id) => api.delete(e.ressource(id)),
  uploadRessourceFichier: (id, formData) => api.post(e.ressourceFichiers(id), formData),
  deleteRessourceFichier: (fichierId) => api.delete(e.ressourceFichier(fichierId)),
  /** URL de consultation d'un justificatif (streamé same-origin). */
  ressourceFichierPdfUrl: (fichierId) => e.ressourceFichierPdf(fichierId),
  pendingCount: () => api.get(e.pendingCount()),
  competenceCategories: () => api.get(e.competenceCategories()),
  availableImages: () => api.get(e.availableImages()),

  getFull: (slug) => api.get(e.full(slug)),
  /** PDF en blob (aperçu intégré same-origin, contourne la CSP frame-src S3). */
  pdf: (slug) => api.get(e.pdf(slug), { responseType: 'blob' }),
  create: (payload) => api.post(e.create(), payload),
  update: (slug, payload) => api.patch(e.update(slug), payload),
  /** Suppression définitive d'une fiche ou d'un document (tout statut). */
  deleteEntry: (slug) => api.delete(e.update(slug)),
  setStatus: (slug, status) => api.post(e.setStatus(slug), { status }),
  generateFromUrl: (payload) => api.post(e.generateFromUrl(), payload),
  uploadImage: (slug, formData) => api.post(e.uploadImage(slug), formData),
  /** Import d'un PDF externe qui remplace le PDF généré de la fiche. */
  uploadPdf: (slug, formData) => api.post(e.uploadPdf(slug), formData),
  /** Retire l'import : le PDF est régénéré depuis le contenu de la fiche. */
  deleteImportedPdf: (slug) => api.delete(e.uploadPdf(slug)),

  /** categories: string[] → joint en CSV comme l'appel d'origine. */
  recipients: (slug, categories = []) => api.get(e.recipients(slug, categories.join(','))),
  /** Journal de diffusion réel (à qui la fiche a été envoyée + statut). */
  diffusionLog: (slug) => api.get(e.diffusionLog(slug)),
  /** Audience de diffusion propre à la fiche (onglet « Diffusion »). */
  setDiffusion: (slug, payload) => api.put(e.setDiffusion(slug), payload),
  send: (slug, payload) => api.post(e.send(slug), payload),
  scheduled: (slug) => api.get(e.scheduled(slug)),
  cancelScheduled: (slug, id) => api.delete(e.cancelScheduled(slug, id)),
}
